import IngresoAuxiliar from "../../IngresoAuxiliar";

const EditarAuxiliarModal = ({ isOpen, auxiliarId, onClose, onSaved, anchoLimitado = false }) => {
    if (!isOpen || !auxiliarId) return null;

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }} tabIndex="-1">
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" style={anchoLimitado ? undefined : { maxWidth: "96vw" }}>
                <div className="modal-content" style={{ maxHeight: "94vh" }}>
                    <div className="modal-header">
                        <h5 className="modal-title">
                            <i className="bi bi-person-gear me-2"></i>
                            Editar Auxiliar
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body bg-light overflow-auto p-3">
                        <IngresoAuxiliar idAuxiliar={auxiliarId} onSuccess={onSaved} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditarAuxiliarModal;
